// This function escapes special characters in a string to be used in a regular expression.
// It replaces characters like . * + ? ^ $ { } ( ) | [ ] \ with their escaped versions.
export function escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[]\]/g, '\$&');
    }